module.exports = __webpack_public_path__ + "img/sld_scb_31_t1_b1_green.124f357c.svg";